import styled from 'styled-components';

import { A } from '@main/core-ui';
import { timing } from '@main/theme';

/**
 * A link
 */
export const Link = styled(A)`
  transition: ${timing.short} opacity;
  &:hover {
    opacity: 0.7;
  }
`;
